import Swiper from 'swiper/bundle';
// init Swiper for home-banner-slider-one :
const bannerSwiperOne = new Swiper(' .home-banner-slider-one', {
  direction: "vertical",
  loop:true,
  spaceBetween: 20,
  loopedSlides:3,
  slidesPerView:3,
  // centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
  // when window width is >= 768px
  768: {
      spaceBetween: 30
    }
  }
});
const bannerSwiperTwo = new Swiper(' .home-banner-slider-two', {
  direction: "vertical",
  loop:true,
  loopedSlides:3,
  slidesPerView:3,
  spaceBetween: 20,
  // centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    reverseDirection:true,
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    // when window width is >= 768px
    768: {
      spaceBetween: 30
    }
  }
});